import { useEffect, useState } from "react";

export default function usePersist() {
  const [persist, setPersist] = useState<boolean>(true);  // Always true

    useEffect(() => {
        // Set persist in localStorage if needed, but we don't toggle the value
        localStorage.setItem("persist", JSON.stringify(persist));
    }, [persist]);

    return [persist, setPersist] as const;
}
